import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveAnamnesisCatalog() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((questionId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = questionId
      ? quarkusApi.put(`/anamnesis-catalog/${questionId}`, payload, authHeader)
      : quarkusApi.post('/anamnesis-catalog', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
